// @ts-ignore
import { useState } from 'react';
import * as React from 'react';

import { IControlError, IControlSchema } from '../../../core/Controls';
import { I18NString } from '../../helpers/Utils';
import { IDispatcher } from '../../helpers/Dispatcher';

import { usePropsValueToState } from '../../../hooks/usePropsValueToState';
import WorkExperienceItem, { ExperienceItem } from './WorkExperienceItem';
import ExtraWrapper from '../components/ExtraWrapper';

export interface IWorkExperienceListSchema extends IControlSchema {
  description: I18NString;
  notification: I18NString;
  maxLength: number;
  minLength: number;
  disabled?: boolean;
  placeholder?: string;
  defaultValue?: {
    ru: string;
    en: string;
  };
  isInteger?: boolean;
  lines?: number;
  value?: ExperienceItem[];
  min?: number;
  max?: number;
  label?: string;
  extra: any;
  mask?: string;
  maskChar?: string;
  size?: number;
  field?: string;
}

export interface IWorkExperienceListProps {
  schema: IWorkExperienceListSchema;
  api: any;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
  controlValue?: any;
}

interface IState {
  value: string;
  openInfo: boolean;
  openNotification: boolean;
}

/**
 * Отдает очищенное имя от всего пути (чтоб создать в объекте значений)
 */
const getI18nPropertyName = (componentId: string, path: string) => {
  return path.replace(componentId + '.', '');
};

/**
 * Отдает пустой объект который нужен для пустого values
 * @param i18n
 * @param i18nControls
 */
const getEmptyItem = ({ i18n, i18nControls }, componentId) => {
  const emptyItem: { [key: string]: any } = {
    dateTo: '',
    dateFrom: '',
  };
  const isHaveI18n = !!i18n;
  const isHaveControlForI18n = !!i18nControls;

  if (isHaveI18n) {
    emptyItem.comment_ru = '';
    if (isHaveControlForI18n) {
      emptyItem[getI18nPropertyName(componentId, i18n)] = '';
    }
  } else {
    emptyItem.comment = '';
  }

  return emptyItem;
};

export const WorkExperienceList = ({
  schema,
  visited,
  error,
  dispatcher,
  api,
}: IWorkExperienceListProps) => {
  const emptyItem = getEmptyItem(
    schema?.extra ?? {},
    schema.id ?? schema.field,
  );
  const [value, setValue, updateValue, deleteValue] = usePropsValueToState(
    schema?.value ?? [emptyItem],
    onBlur,
  );

  function onBlur(value) {
    return dispatcher.onBlur(
      schema.id,
      value,
      !error,
      error && error.isError && { message: error.message },
    );
  }
  function dateToTime(str) {
    return new Date(str).getTime();
  }

  return (
    <ExtraWrapper
      schema={schema}
      visited={visited}
      error={error}
      dispatcher={dispatcher}
      value={value}
    >
      {value
        ? value
            .sort((a, b) => dateToTime(a.dateFrom) - dateToTime(b.dateFrom))
            .map((item, index) => {
              return (
                <WorkExperienceItem
                  item={item}
                  index={index}
                  updateValue={updateValue}
                  deleteValue={deleteValue}
                  i18nPropertyName={
                    schema?.extra?.i18nControls
                      ? getI18nPropertyName(
                          schema.id ?? schema.field,
                          schema.extra.i18n,
                        )
                      : undefined
                  }
                  isHaveI18n={!!schema?.extra?.i18n}
                  maxLength={schema.maxLength}
                  minLength={schema.minLength}
                />
              );
            })
        : null}

      <button
        type="button"
        className="btn btn-primary"
        onClick={() => {
          setValue([...value, emptyItem]);
        }}
      >
        Добавить
      </button>
    </ExtraWrapper>
  );
};

export function createWorkExperienceList(
  schema: IControlSchema,
  api: any,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <WorkExperienceList
      schema={schema as IWorkExperienceListSchema}
      api={api}
      dispatcher={dispatcher}
      error={error}
      visited={visited}
    />
  );
}
